var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-carousel',{staticStyle:{"width":"800px"},attrs:{"trigger":"click","height":"250px","interval":3000,"arrow":"always"}},_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{key:item.name},[_c('img',{staticStyle:{"height":"100px","width":"100px"},attrs:{"src":item.src,"alt":"图片丢失了","title":item.title}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e35c26e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 